import { NavController, LoadingController, AlertController, Keyboard,ToastController } from 'ionic-angular';
import { Component, ViewChild } from '@angular/core';
import { UserService } from "../../services/user.services";
import { AppConfigService } from "../../services/appConfig.service";
import { AppDialog } from "../../component/appDialog";
import { DepositListPage } from "../depositList/depositList";
import { RechargeWebsitePage } from "../service/rechargeWebsite";
import { HomePage } from "../home/home";
import { LoginPage } from "../login/login";
import { RechargeZaloPayPage } from "../rechargeZaloPay/rechargeZaloPay";
import { Content } from 'ionic-angular';
import { PaymentCodeViewPage } from '../paymentCode/paymentCodeView';
import { CommonUtil } from "../../util/commonUtil";

@Component({
    templateUrl: 'recharge.html',
    selector: 'recharge-page',
})
export class RechargePage {
    selectAction: string = "action1";
    bankList: any = [];
    depositCode: any = [];
    depositManual: any;
    shownGroup = null;
    starttime: string;
    endtime: string;
    //充值编号
    id: string;
    userName: string;

    zaloList: any = [];
    tabList: any[] = [];
    tabSelect: string = 'OFFLINE';
    accountList: Array<Array<any>> = [];
    public userID = LoginPage.userID;

    title: string;
    accName: string='test copy acc';
    accNo: string;
    paymentCode: string;
    isSelected: boolean = false;

    cardItems = [
        { content: 'Card 1' },
        { content: 'Card 2' },
        { content: 'Card 3' },
      ];
    
  // Process the array to create pairs of items

    @ViewChild(Content) content: Content;
    constructor(private keyboard: Keyboard, private nav: NavController, private userService: UserService,
        private alertCtrl: AlertController, public loadingCtrl: LoadingController,private toastCtrl: ToastController,) {
        this.initService();
        this.userName = HomePage.loginname;
    }

    copy(url: string) {
        CommonUtil.copyToClipboard(url, this.toastCtrl);
    }

    handleCardClicked() {
        this.isSelected = !this.isSelected;
        console.log('Card clicked!');
        // Add your logic here
      }
    initService() {
        this.userService.deposit(undefined, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.bankList = data["bankcardlist"].filter(item => item['remark'] !== 'zalopay');
                this.zaloList = data["bankcardlist"].filter(item => item['remark'] === 'zalopay');
                this.depositCode = data["listDepositCode"];
                this.depositManual = data["depositManual"];
                this.tabList = data['tabList'];
                this.bankList.map(item => {
                    item.targetBlank = false;
                    if (item.icon === 'help2pay') {
                        item.targetBlank = true;
                        item.address = item.address.replace(/[%s]/g, '') + this.userName;
                    }
                });
                this.filterTabMatch(this.tabSelect);
            }
        });
        this.userService.depositSearchInit(undefined, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.starttime = data["stime"].replace(" ", "T");
                this.endtime = data["etime"].replace(" ", "T");
            }
        });
    }

    private pairItems(items: Array<any>, itemsPerRow: number = 2): Array<Array<any>> {
        const paired = [];
        for (let i = 0; i < items.length; i += itemsPerRow) {
          paired.push(items.slice(i, i + itemsPerRow));
        }
        return paired;
      }

    filterTabMatch(tabSelect: string) {
        // filter lottery list
        this.accountList = this.bankList.filter((item) => item.tabtype === this.tabSelect);
        console.log(" this.accountList", this.accountList);
        

    }

    handleChangeTab(tabValue: any) {
        this.tabSelect = tabValue;
        this.filterTabMatch(tabValue);
    }

    goPaymentCode(item:any) {
        switch (item.tabtype) {
            case 'OFFLINE':
                this.nav.push(PaymentCodeViewPage, {
                    accName: item.showbankcard,
                    accNo: item.bankcard,
                    paymentCode: item.paymentCode,
                    name: item.name,
                });
                break;
            case 'ONLINE':
            case 'EWALLET':
                AppDialog.toast({
                    toastCtrl: this.toastCtrl,
                    message: 'Comming Soon',
                });
                break;
        };

    }

    goWebsite(url: string, iconBank: string, remark: string) {
        let arrFastDeposit = ['atmonline', 'qrcode', 'nganluong', 'help2pay'];
        if (arrFastDeposit.indexOf(iconBank) < 0) {
            let code;
            if (this.depositCode.length > 0)
                code = this.depositCode[Math.floor(Math.random() * this.depositCode.length)]; // random code deposit
            else
                code = 'UIDT'; // default UIDT if list deposit code empty

            url = url + "&uidt=" + code + this.userID + "&manual=" + this.depositManual;
        }
        this.nav.push(RechargeWebsitePage, {
            url: url
        });
    }

    searchFn() {
        let postData = {
            stime: this.starttime.replace("T", ' ').substr(0, 19),
            etime: this.endtime.replace("T", ' ').substr(0, 19),
            id: this.id
        };
        this.userService.depositSearch(postData, this).then(data => {
            if (!data["msg"]) {
                this.nav.push(DepositListPage, {
                    postData: postData,
                    data: data
                });
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    ionViewWillLeave() {
        this.keyboard.close();
    }

    goZaloPayPage() {
        let code = 'UIDT'; // default UIDT if list deposit code empty
        if (this.depositCode.length > 0) code = this.depositCode[Math.floor(Math.random() * this.depositCode.length)]; // random code deposit
        this.nav.push(RechargeZaloPayPage, {
            uidt: code + this.userID,
            zaloList: this.zaloList
        });
    }
    toggleGroup = function (group) {
        if (this.isGroupShown(group)) {
            this.shownGroup = null;
        } else {
            this.shownGroup = group;
            setTimeout(() => {
                this.scrollToElement(group);
            }, 100);
        }
    };
    isGroupShown = function (group) {
        return this.shownGroup === group;
    };
    scrollToElement(id) {
        let el = document.getElementById(id);
        let offsetTop = el.offsetTop;
        // scrollLeft as 0px, scrollTop as "topBound"px, move in 800 milliseconds
        this.content.scrollTo(0, offsetTop - 10, 0);
    }
}



// WEBPACK FOOTER //
// ./src/pages/recharge/recharge.ts